export default {
  title: '機密保持契約',
  dialog: {
    cancel: 'キャンセル',
    agree: '同意',
  },
}
